import { render } from "./SubForm.vue?vue&type=template&id=30249ebc"
import script from "./SubForm.vue?vue&type=script&lang=js"
export * from "./SubForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__